import { Viewable } from '../protocols/viewable';
import { Subscribable } from './subscribable';
import { TemplateLayerTypeUtils } from '../../utils/template-layer-type-utils';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-base',
  template: '',
  standalone: false
})
export abstract class BaseComponent extends Subscribable implements OnInit, AfterViewInit, OnDestroy, Viewable {
  abstract setupViews();
  abstract setupBindings();

  public rendered = new BehaviorSubject<boolean>(false);
  Types = TemplateLayerTypeUtils;

  ngOnInit(): void {
    window.injector.isReadyService.globalSignalCreated(this.rendered);
    this.setupViews();
  }

  ngAfterViewInit(): void {
    this.rendered.next(true);
    this.setupBindings();
  }

  ngOnDestroy() {
    window.injector.isReadyService.globalSignalDestroyed(this.rendered);
    super.ngOnDestroy();
  }
}
